/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { InstallMethod } from '../../constants/installation';

export function getStylesImport( installMethod: InstallMethod | null, hasPremiumPlugins: boolean ): string {
	if ( installMethod !== 'npm' ) {
		return '';
	}

	const imports = [
		'import \'ckeditor5/ckeditor5.css\';'
	];

	if ( hasPremiumPlugins ) {
		imports.push( 'import \'ckeditor5-premium-features/ckeditor5-premium-features.css\';' );
	}

	return imports.join( '\n' );
}
